import React, { useEffect, memo } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { AiOutlineClose } from "react-icons/ai";

const MatchModalHeader = ({
  title = "",
  currentData = {},
  setCurrentData = () => {},
  currentIndex = 0,
  setCurrentIndex = () => {},
  reportsData = [],
  closeModal = () => {},
}) => {
  const lastIndex = reportsData?.length - 1;
  const handleBack = () => {
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === lastIndex ? prev : prev + 1));
  };

  useEffect(() => {
    const data = reportsData[currentIndex];
    setCurrentData(data);
    // eslint-disable-next-line
  }, [currentIndex]);

  return (
    <div className="w-100 d-flex justify-content-between flex-wrap gap-2 gap-lg-0 position-relative p-3">
      <h4>{title}</h4>
      {!!reportsData.length && (
        <div className="scroll d-flex align-items-center flex-shrink-0 justify-content-center float-start float-sm-none flex">
          <h4>
            <IoIosArrowBack
              onClick={() => handleBack()}
              style={{
                cursor: "pointer",
                color:
                  currentData?.id === reportsData[0]?.id ? "lightgray" : "black",
              }}
            />
            <IoIosArrowForward
              onClick={() => handleNext()}
              style={{
                cursor: "pointer",
                color:
                  currentData?.id === reportsData[lastIndex]?.id
                    ? "lightgray"
                    : "black",
              }}
            />
          </h4>
          <span>
            {currentIndex + 1} / {reportsData.length}
          </span>
        </div>
      )}
      <button
        className={
          `d-sm-none d-block btn btn-sm btn-dark p-2 m-0 bg-transparent link-hover shadow-none rounded-circle`
        }
        style={{
          color: "#6754e2",
          top: "-20px",
          right: "-20px",
        }}
        onClick={closeModal}
      >
        <AiOutlineClose style={{ fontSize: "25px", fontWeight: "bolder" }} />
      </button>
    </div>
  )
}

export default memo(MatchModalHeader);
